export default "__VITE_ASSET__D$P1FUxo__"